import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(['sub-category']),
  style: {
    "display": "flex",
    "flex-flow": "row nowrap"
  }
};
const _hoisted_2 = {
  class: "GHGroup"
};
const _hoisted_3 = {
  class: "GHGroupTitle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GHSubGroup = _resolveComponent("GHSubGroup");
  const _directive_loading = _resolveDirective("loading");
  return $options.hasVisibleIcons ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: "OperatorLayout",
    style: _normalizeStyle({
      'height': `${$props.rows * 40}px`
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleGroups, (group, index) => {
    return _openBlock(), _createBlock(_component_GHSubGroup, {
      key: index,
      group: group,
      rows: $props.rows,
      "highlighted-icon-id": _ctx.highlightedIconId,
      onClickComp: $options.sendCompNameInUrl
    }, null, 8, ["group", "rows", "highlighted-icon-id", "onClickComp"]);
  }), 128))], 4)), [[_directive_loading, $data.isLoading]]), _createElementVNode("div", _hoisted_3, _toDisplayString($props.subCategory.name), 1)])])) : _createCommentVNode("", true);
}